(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gkbsfs310-before-order-cooler-calmer-bed-260723"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootSelector = '[data-gkherofs-boccb-root-0726]';

    const initialize = (root) => {
      if (root.dataset.gkherofsBoccbReady0726 === 'true') return;

      const openButton = root.querySelector(
        '[data-gkherofs-boccb-open-0726]'
      );

      const dialog = root.querySelector(
        '[data-gkherofs-boccb-dialog-0726]'
      );

      if (!openButton || !dialog) return;

      const closeButton = dialog.querySelector(
        '[data-gkherofs-boccb-close-0726]'
      );

      const targetButtons = dialog.querySelectorAll(
        '[data-gkherofs-boccb-target-0726]'
      );

      const controller = new AbortController();
      const { signal } = controller;
      let previousFocus = null;
      let previousBodyOverflow = '';

      root.dataset.gkherofsBoccbReady0726 = 'true';

      const getFocusable = () => {
        return Array.from(
          dialog.querySelectorAll(
            'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
          )
        ).filter((item) => !item.hidden);
      };

      const closeDialog = (restoreFocus = true) => {
        if (dialog.hidden) return;

        dialog.hidden = true;
        document.body.style.overflow = previousBodyOverflow;

        if (
          restoreFocus &&
          previousFocus instanceof HTMLElement
        ) {
          previousFocus.focus();
        }
      };

      const openDialog = () => {
        previousFocus = document.activeElement;
        previousBodyOverflow = document.body.style.overflow;
        dialog.hidden = false;
        document.body.style.overflow = 'hidden';

        window.requestAnimationFrame(() => {
          closeButton?.focus();
        });
      };

      openButton.addEventListener('click', openDialog, { signal });

      closeButton?.addEventListener(
        'click',
        () => closeDialog(),
        { signal }
      );

      dialog.addEventListener(
        'mousedown',
        (event) => {
          if (event.target === dialog) {
            closeDialog();
          }
        },
        { signal }
      );

      dialog.addEventListener(
        'keydown',
        (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            closeDialog();
            return;
          }

          if (event.key !== 'Tab') return;

          const focusable = getFocusable();
          if (focusable.length === 0) return;

          const first = focusable[0];
          const last = focusable[focusable.length - 1];

          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (
            !event.shiftKey &&
            document.activeElement === last
          ) {
            event.preventDefault();
            first.focus();
          }
        },
        { signal }
      );

      targetButtons.forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            const targetId = button.dataset.gkherofsBoccbTarget0726;
            const target = targetId
              ? document.getElementById(targetId)
              : null;

            closeDialog(false);

            if (!target) return;

            window.requestAnimationFrame(() => {
              const top =
                target.getBoundingClientRect().top +
                window.scrollY -
                80;

              window.scrollTo({
                top,
                behavior: window.matchMedia(
                  '(prefers-reduced-motion: reduce)'
                ).matches
                  ? 'auto'
                  : 'smooth'
              });

              if (!target.hasAttribute('tabindex')) {
                target.setAttribute('tabindex', '-1');
              }

              target.focus({ preventScroll: true });
            });
          },
          { signal }
        );
      });

      root.gkherofsBoccbCleanup0726 = () => {
        closeDialog(false);
        controller.abort();
        delete root.dataset.gkherofsBoccbReady0726;
      };
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll(rootSelector).forEach(initialize);
    };

    initializeAll();

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        initializeAll(event.target);
      }
    );

    document.addEventListener(
      'shopify:section:unload',
      (event) => {
        event.target
          .querySelectorAll(rootSelector)
          .forEach((root) => {
            root.gkherofsBoccbCleanup0726?.();
          });
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gkbsfs310-comfort-proof-260723"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector = '[data-gkpdprv-cptfc-section-0726]';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const initialize = (root) => {
      if (root.dataset.gkpdprvCptfcReady0726 === 'true') return;

      const marquee = root.querySelector('[data-gkpdprv-cptfc-marquee-0726]');
      if (!marquee) return;

      root.dataset.gkpdprvCptfcReady0726 = 'true';

      let inView = true;
      let pageVisible = !document.hidden;

      const canRun = () => {
        return (
          root.dataset.autoplay === 'true' &&
          !reducedMotion.matches &&
          inView &&
          pageVisible
        );
      };

      const update = () => {
        marquee.dataset.motionState = canRun() ? 'running' : 'paused';
      };

      const onVisibilityChange = () => {
        pageVisible = !document.hidden;
        update();
      };

      document.addEventListener('visibilitychange', onVisibilityChange);

      const observer =
        'IntersectionObserver' in window
          ? new IntersectionObserver(
              (entries) => {
                inView = entries[0]?.isIntersecting ?? true;
                update();
              },
              {
                rootMargin: '50px',
                threshold: 0.1
              }
            )
          : null;

      observer?.observe(marquee);

      root.gkpdprvCptfcCleanup0726 = () => {
        observer?.disconnect();
        document.removeEventListener('visibilitychange', onVisibilityChange);
      };

      update();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll(sectionSelector).forEach(initialize);
    };

    initializeAll();

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(sectionSelector).forEach((root) => {
        root.gkpdprvCptfcCleanup0726?.();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gkbsfs310-home-hero-260723"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-gkherofs-scroll-link-0726]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const href = link.getAttribute('href');
      if (!href || !href.startsWith('#')) return;
      const target = document.querySelector(href);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gkbsfs310-mobile-sticky-260723"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gkstickyfs-mobile-sticky-0726')) {
    class GkstickyfsMobileSticky0726 extends HTMLElement {
      connectedCallback() {
        if (this.gkstickyfsConnected0726) return;
        this.gkstickyfsConnected0726 = true;
        this.gkstickyfsRetryCount0726 = 0;
        this.gkstickyfsLoading0726 = false;

        this.gkstickyfsPrice0726 = this.querySelector(
          '[data-gkstickyfs-price-0726]'
        );
        this.gkstickyfsVariantLabel0726 = this.querySelector(
          '[data-gkstickyfs-variant-label-0726]'
        );
        this.gkstickyfsButton0726 = this.querySelector(
          '[data-gkstickyfs-add-0726]'
        );
        this.gkstickyfsButtonText0726 = this.querySelector(
          '[data-gkstickyfs-button-text-0726]'
        );

        this.gkstickyfsVariants0726 = this.gkstickyfsParseJson0726(
          '[data-gkstickyfs-variants-0726]',
          []
        );
        this.gkstickyfsOptionNames0726 = this.gkstickyfsParseJson0726(
          '[data-gkstickyfs-option-names-0726]',
          []
        );

        this.gkstickyfsAddHandler0726 = (e) => {
          e.stopPropagation();
          this.gkstickyfsAddToCart0726();
        };

        this.gkstickyfsInteractionHandler0726 = (event) => {
          if (
            event.target === this.gkstickyfsButton0726 ||
            this.contains(event.target)
          ) {
            return;
          }

          window.clearTimeout(this.gkstickyfsInteractionTimer0726);
          this.gkstickyfsInteractionTimer0726 = window.setTimeout(() => {
            this.gkstickyfsRefreshBindings0726();
            this.gkstickyfsSync0726();
          }, 0);

          window.clearTimeout(this.gkstickyfsSettledTimer0726);
          this.gkstickyfsSettledTimer0726 = window.setTimeout(() => {
            this.gkstickyfsRefreshBindings0726();
            this.gkstickyfsSync0726();
          }, 90);
        };

        this.gkstickyfsVariantHandler0726 = (event) => {
          const gkstickyfsVariant0726 =
            event.detail && event.detail.variant
              ? event.detail.variant
              : null;

          if (gkstickyfsVariant0726) {
            const gkstickyfsMatchesProduct0726 =
              this.gkstickyfsVariants0726.some(
                (item) =>
                  String(item.id) ===
                  String(gkstickyfsVariant0726.id)
              );

            if (!gkstickyfsMatchesProduct0726) return;
            this.gkstickyfsCurrentVariant0726 =
              gkstickyfsVariant0726;
          }

          this.gkstickyfsInteractionHandler0726(event);
        };

        this.gkstickyfsCartCompleteHandler0726 = () => {
          this.gkstickyfsSetLoading0726(false);
          this.gkstickyfsSync0726();
        };

        this.gkstickyfsButton0726?.addEventListener(
          'click',
          this.gkstickyfsAddHandler0726
        );

        this.addEventListener('click', (e) => {
          if (this.gkstickyfsButton0726?.contains(e.target)) return;
          const customLink = this.getAttribute('data-gkstickyfs-custom-link-0726');
          if (customLink && customLink.trim() !== '') {
            window.location.href = customLink;
          }
        });

        document.addEventListener(
          'variant:change',
          this.gkstickyfsVariantHandler0726
        );
        document.addEventListener(
          'change',
          this.gkstickyfsInteractionHandler0726,
          true
        );
        document.addEventListener(
          'input',
          this.gkstickyfsInteractionHandler0726,
          true
        );
        document.addEventListener(
          'click',
          this.gkstickyfsInteractionHandler0726
        );
        document.addEventListener(
          'cart:updated',
          this.gkstickyfsCartCompleteHandler0726
        );
        document.addEventListener(
          'ajaxProduct:added',
          this.gkstickyfsCartCompleteHandler0726
        );

        this.gkstickyfsInitialize0726();
      }

      gkstickyfsParseJson0726(selector, fallback) {
        const gkstickyfsNode0726 = this.querySelector(selector);
        if (!gkstickyfsNode0726) return fallback;

        try {
          return JSON.parse(gkstickyfsNode0726.textContent);
        } catch (error) {
          return fallback;
        }
      }

      gkstickyfsInitialize0726() {
        this.gkstickyfsRefreshBindings0726();

        if (!this.gkstickyfsProductForm0726) {
          if (this.gkstickyfsRetryCount0726 < 40) {
            this.gkstickyfsRetryCount0726 += 1;
            window.clearTimeout(this.gkstickyfsRetryTimer0726);
            this.gkstickyfsRetryTimer0726 = window.setTimeout(
              () => this.gkstickyfsInitialize0726(),
              100
            );
          } else {
            this.gkstickyfsSetUnavailable0726(true);
          }
          return;
        }

        this.gkstickyfsObserveProduct0726();
        this.gkstickyfsSync0726();
      }

      gkstickyfsRefreshBindings0726() {
        const gkstickyfsProductId0726 = String(
          this.getAttribute('data-gkstickyfs-product-id-0726') || ''
        );

        let gkstickyfsProductRoot0726 = document.querySelector(
          '.product-section[data-product-id="' +
            gkstickyfsProductId0726 +
            '"]'
        );

        if (!gkstickyfsProductRoot0726) {
          gkstickyfsProductRoot0726 =
            document.querySelector('.product-section') ||
            document.querySelector('[data-product-section]');
        }

        let gkstickyfsProductForm0726 =
          gkstickyfsProductRoot0726?.querySelector(
            'form[action*="/cart/add"]'
          );

        if (!gkstickyfsProductForm0726) {
          const gkstickyfsForms0726 = Array.from(
            document.querySelectorAll('form[action*="/cart/add"]')
          );

          gkstickyfsProductForm0726 =
            gkstickyfsForms0726.find((form) => {
              const input = form.querySelector('[name="id"]');
              return this.gkstickyfsVariants0726.some(
                (variant) =>
                  input &&
                  String(variant.id) === String(input.value)
              );
            }) || null;
        }

        if (!gkstickyfsProductForm0726) return;

        if (!gkstickyfsProductRoot0726) {
          gkstickyfsProductRoot0726 =
            gkstickyfsProductForm0726.closest('.product-section') ||
            gkstickyfsProductForm0726.parentElement;
        }

        this.gkstickyfsProductRoot0726 =
          gkstickyfsProductRoot0726;
        this.gkstickyfsProductForm0726 =
          gkstickyfsProductForm0726;
        this.gkstickyfsVariantInput0726 =
          gkstickyfsProductForm0726.querySelector('[name="id"]');
        this.gkstickyfsQuantityInput0726 =
          gkstickyfsProductForm0726.querySelector(
            'input[name="quantity"]'
          );

        if (!this.gkstickyfsQuantityInput0726) {
          const gkstickyfsQuantityInputs0726 =
            gkstickyfsProductRoot0726?.querySelectorAll(
              'input[name="quantity"]'
            ) || [];

          gkstickyfsQuantityInputs0726.forEach((input) => {
            if (
              !this.gkstickyfsQuantityInput0726 &&
              input.form === gkstickyfsProductForm0726
            ) {
              this.gkstickyfsQuantityInput0726 = input;
            }
          });
        }

        this.gkstickyfsNativeButton0726 =
          gkstickyfsProductForm0726.querySelector(
            '[data-add-to-cart]'
          ) ||
          gkstickyfsProductForm0726.querySelector(
            '.add-to-cart'
          ) ||
          gkstickyfsProductForm0726.querySelector(
            'button[name="add"]'
          ) ||
          gkstickyfsProductForm0726.querySelector(
            'button[type="submit"]'
          );
      }

      gkstickyfsObserveProduct0726() {
        if (
          this.gkstickyfsObservedRoot0726 ===
            this.gkstickyfsProductRoot0726 &&
          this.gkstickyfsProductObserver0726
        ) {
          return;
        }

        this.gkstickyfsProductObserver0726?.disconnect();
        this.gkstickyfsObservedRoot0726 =
          this.gkstickyfsProductRoot0726;

        if (!this.gkstickyfsObservedRoot0726) return;

        this.gkstickyfsProductObserver0726 =
          new MutationObserver(() => {
            window.clearTimeout(
              this.gkstickyfsMutationTimer0726
            );
            this.gkstickyfsMutationTimer0726 =
              window.setTimeout(() => {
                this.gkstickyfsRefreshBindings0726();
                this.gkstickyfsSync0726();
              }, 20);
          });

        this.gkstickyfsProductObserver0726.observe(
          this.gkstickyfsObservedRoot0726,
          {
            childList: true,
            characterData: true,
            subtree: true
          }
        );
      }

      gkstickyfsGetVariant0726() {
        const gkstickyfsVariantId0726 =
          this.gkstickyfsVariantInput0726?.value;

        const gkstickyfsVariant0726 =
          this.gkstickyfsVariants0726.find(
            (item) =>
              String(item.id) ===
              String(gkstickyfsVariantId0726)
          );

        if (gkstickyfsVariant0726) {
          this.gkstickyfsCurrentVariant0726 =
            gkstickyfsVariant0726;
        }

        return (
          gkstickyfsVariant0726 ||
          this.gkstickyfsCurrentVariant0726 ||
          this.gkstickyfsVariants0726[0]
        );
      }

      gkstickyfsGetQuantity0726() {
        const gkstickyfsQuantity0726 = Number.parseInt(
          this.gkstickyfsQuantityInput0726?.value || '1',
          10
        );

        return Number.isFinite(gkstickyfsQuantity0726)
          ? Math.max(1, gkstickyfsQuantity0726)
          : 1;
      }

      gkstickyfsGetVariantLabel0726(variant) {
        if (!variant) return '';

        const gkstickyfsOptions0726 =
          Array.isArray(variant.options)
            ? variant.options
            : [
                variant.option1,
                variant.option2,
                variant.option3
              ].filter(Boolean);

        const gkstickyfsSizeIndex0726 =
          this.gkstickyfsOptionNames0726.findIndex((name) =>
            /size/i.test(String(name))
          );
        const gkstickyfsColorIndex0726 =
          this.gkstickyfsOptionNames0726.findIndex((name) =>
            /colou?r/i.test(String(name))
          );
        const gkstickyfsLabelParts0726 = [];

        if (
          gkstickyfsSizeIndex0726 >= 0 &&
          gkstickyfsOptions0726[gkstickyfsSizeIndex0726]
        ) {
          gkstickyfsLabelParts0726.push(
            gkstickyfsOptions0726[gkstickyfsSizeIndex0726]
          );
        }

        if (
          gkstickyfsColorIndex0726 >= 0 &&
          gkstickyfsOptions0726[gkstickyfsColorIndex0726]
        ) {
          gkstickyfsLabelParts0726.push(
            gkstickyfsOptions0726[gkstickyfsColorIndex0726]
          );
        }

        if (gkstickyfsLabelParts0726.length > 0) {
          return gkstickyfsLabelParts0726.join(' · ');
        }

        if (
          variant.title &&
          variant.title !== 'Default Title'
        ) {
          return variant.title.replace(/\s*\/\s*/g, ' · ');
        }

        return '';
      }

      gkstickyfsGetTotal0726(variant, quantity) {
        const gkstickyfsUnitPrice0726 = Number(
          variant?.price || 0
        );
        const gkstickyfsDiscount0726 = Number(
          this.getAttribute(
            'data-gkstickyfs-discount-0726'
          ) || 0
        );

        if (quantity === 2 && gkstickyfsDiscount0726 > 0) {
          return Math.round(
            gkstickyfsUnitPrice0726 *
              quantity *
              ((100 - gkstickyfsDiscount0726) / 100)
          );
        }

        return gkstickyfsUnitPrice0726 * quantity;
      }

      gkstickyfsGetNativePrice0726() {
        if (
          this.getAttribute(
            'data-gkstickyfs-use-native-price-0726'
          ) !== 'true'
        ) {
          return '';
        }

        const gkstickyfsPriceTarget0726 =
          this.gkstickyfsNativeButton0726?.querySelector(
            '[data-btn-price-260401]'
          ) ||
          this.gkstickyfsNativeButton0726?.querySelector(
            '[data-btn-price]'
          );

        return gkstickyfsPriceTarget0726?.textContent.trim() || '';
      }

      gkstickyfsSync0726() {
        const customLink = this.getAttribute('data-gkstickyfs-custom-link-0726');
        if (customLink && customLink.trim() !== '') {
          return;
        }

        const gkstickyfsVariant0726 =
          this.gkstickyfsGetVariant0726();
        const gkstickyfsQuantity0726 =
          this.gkstickyfsGetQuantity0726();
        const gkstickyfsIsAvailable0726 =
          Boolean(gkstickyfsVariant0726?.available) &&
          Boolean(this.gkstickyfsProductForm0726);
        const gkstickyfsVariantLabel0726 =
          this.gkstickyfsGetVariantLabel0726(
            gkstickyfsVariant0726
          );
        const gkstickyfsCalculatedPrice0726 =
          this.gkstickyfsFormatMoney0726(
            this.gkstickyfsGetTotal0726(
              gkstickyfsVariant0726,
              gkstickyfsQuantity0726
            )
          );
        const gkstickyfsNativePrice0726 =
          this.gkstickyfsGetNativePrice0726();

        if (
          this.gkstickyfsVariantLabel0726 &&
          gkstickyfsVariantLabel0726
        ) {
          this.gkstickyfsVariantLabel0726.textContent =
            gkstickyfsVariantLabel0726;
        }

        if (this.gkstickyfsPrice0726) {
          this.gkstickyfsPrice0726.textContent =
            gkstickyfsNativePrice0726 ||
            gkstickyfsCalculatedPrice0726;
        }

        this.gkstickyfsSetUnavailable0726(
          !gkstickyfsIsAvailable0726
        );
      }

      gkstickyfsSetUnavailable0726(isUnavailable) {
        if (!this.gkstickyfsButton0726) return;

        const customLink = this.getAttribute('data-gkstickyfs-custom-link-0726');
        if (customLink && customLink.trim() !== '') {
          return;
        }

        this.gkstickyfsUnavailable0726 = isUnavailable;
        this.gkstickyfsButton0726.disabled =
          isUnavailable || this.gkstickyfsLoading0726;

        if (this.gkstickyfsLoading0726) return;

        const gkstickyfsLabel0726 = isUnavailable
          ? this.getAttribute(
              'data-gkstickyfs-sold-out-label-0726'
            )
          : this.getAttribute(
              'data-gkstickyfs-button-label-0726'
            );

        if (this.gkstickyfsButtonText0726) {
          this.gkstickyfsButtonText0726.textContent =
            gkstickyfsLabel0726 || '';
        }
      }

      gkstickyfsSetLoading0726(isLoading) {
        this.gkstickyfsLoading0726 = isLoading;
        if (!this.gkstickyfsButton0726) return;

        this.gkstickyfsButton0726.disabled =
          isLoading || this.gkstickyfsUnavailable0726;
        this.gkstickyfsButton0726.setAttribute(
          'aria-busy',
          String(isLoading)
        );

        if (this.gkstickyfsButtonText0726) {
          this.gkstickyfsButtonText0726.textContent = isLoading
            ? this.getAttribute(
                'data-gkstickyfs-loading-label-0726'
              ) || ''
            : this.gkstickyfsUnavailable0726
              ? this.getAttribute(
                  'data-gkstickyfs-sold-out-label-0726'
                ) || ''
              : this.getAttribute(
                  'data-gkstickyfs-button-label-0726'
                ) || '';
        }
      }

      gkstickyfsAddToCart0726() {
        const customLink = this.getAttribute('data-gkstickyfs-custom-link-0726');
        if (customLink && customLink.trim() !== '') {
          window.location.href = customLink;
          return;
        }

        this.gkstickyfsRefreshBindings0726();
        this.gkstickyfsSync0726();

        if (
          !this.gkstickyfsProductForm0726 ||
          this.gkstickyfsUnavailable0726 ||
          this.gkstickyfsLoading0726
        ) {
          return;
        }

        this.gkstickyfsSetLoading0726(true);

        if (
          this.gkstickyfsNativeButton0726 &&
          !this.gkstickyfsNativeButton0726.disabled
        ) {
          this.gkstickyfsNativeButton0726.click();
        } else if (
          typeof this.gkstickyfsProductForm0726.requestSubmit ===
          'function'
        ) {
          this.gkstickyfsProductForm0726.requestSubmit();
        } else {
          this.gkstickyfsProductForm0726.submit();
        }

        window.clearTimeout(this.gkstickyfsLoadingTimer0726);
        this.gkstickyfsLoadingTimer0726 = window.setTimeout(
          () => {
            this.gkstickyfsSetLoading0726(false);
            this.gkstickyfsSync0726();
          },
          2200
        );
      }

      gkstickyfsFormatMoney0726(cents) {
        const gkstickyfsMoneyFormat0726 =
          this.getAttribute(
            'data-gkstickyfs-money-format-0726'
          ) || '$' + '{' + '{amount}' + '}';

        if (
          window.theme &&
          window.theme.Currency &&
          typeof window.theme.Currency.formatMoney === 'function'
        ) {
          return this.gkstickyfsPlainText0726(
            window.theme.Currency.formatMoney(
              cents,
              gkstickyfsMoneyFormat0726
            )
          );
        }

        if (
          window.Shopify &&
          typeof window.Shopify.formatMoney === 'function'
        ) {
          return this.gkstickyfsPlainText0726(
            window.Shopify.formatMoney(
              cents,
              gkstickyfsMoneyFormat0726
            )
          );
        }

        const gkstickyfsCurrency0726 =
          this.getAttribute(
            'data-gkstickyfs-currency-0726'
          ) || 'USD';

        try {
          return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: gkstickyfsCurrency0726
          }).format(cents / 100);
        } catch (error) {
          return '$' + (cents / 100).toFixed(2);
        }
      }

      gkstickyfsPlainText0726(value) {
        const gkstickyfsTemporary0726 =
          document.createElement('div');
        gkstickyfsTemporary0726.innerHTML = value;
        return gkstickyfsTemporary0726.textContent.trim();
      }

      disconnectedCallback() {
        window.clearTimeout(this.gkstickyfsRetryTimer0726);
        window.clearTimeout(
          this.gkstickyfsInteractionTimer0726
        );
        window.clearTimeout(this.gkstickyfsSettledTimer0726);
        window.clearTimeout(this.gkstickyfsMutationTimer0726);
        window.clearTimeout(this.gkstickyfsLoadingTimer0726);

        this.gkstickyfsProductObserver0726?.disconnect();
        this.gkstickyfsButton0726?.removeEventListener(
          'click',
          this.gkstickyfsAddHandler0726
        );

        document.removeEventListener(
          'variant:change',
          this.gkstickyfsVariantHandler0726
        );
        document.removeEventListener(
          'change',
          this.gkstickyfsInteractionHandler0726,
          true
        );
        document.removeEventListener(
          'input',
          this.gkstickyfsInteractionHandler0726,
          true
        );
        document.removeEventListener(
          'click',
          this.gkstickyfsInteractionHandler0726
        );
        document.removeEventListener(
          'cart:updated',
          this.gkstickyfsCartCompleteHandler0726
        );
        document.removeEventListener(
          'ajaxProduct:added',
          this.gkstickyfsCartCompleteHandler0726
        );

        this.gkstickyfsConnected0726 = false;
      }
    }

    customElements.define(
      'gkstickyfs-mobile-sticky-0726',
      GkstickyfsMobileSticky0726
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gkbsfs310-product-cta-0720"] && !Shopify.designMode) return;
  try {
    
  function gkbsfs310InitScrollTop0720(scope) {
    const source = scope || document;
    const buttons = source.querySelectorAll('[data-gkbsfs310-scroll-top-0720]');

    buttons.forEach((button) => {
      if (button.dataset.gkbsfs310Ready0720 === 'true') {
        return;
      }
      button.dataset.gkbsfs310Ready0720 = 'true';

      button.addEventListener('click', (event) => {
        event.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    });
  }

  gkbsfs310InitScrollTop0720(document);

  document.addEventListener('shopify:section:load', (event) => {
    gkbsfs310InitScrollTop0720(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gokotta-b9v4s7-final261026"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gk-b9v4s7-final261026')) {
    customElements.define(
      'gk-b9v4s7-final261026',
      class extends HTMLElement {
        connectedCallback() {
          if (this.ready261026) return;
          this.ready261026 = true;

          const button261026 = this.querySelector('[data-scroll261026]');
          if (!button261026) return;

          button261026.addEventListener('click', () => {
            const target261026 = document.querySelector(
              'gk-cedar-sheetshop261026 .gk-cedar-wrap261026'
            );

            if (!target261026) return;

            const top261026 =
              target261026.getBoundingClientRect().top +
              window.scrollY -
              90;

            window.scrollTo({
              top: Math.max(0, top261026),
              behavior: matchMedia(
                '(prefers-reduced-motion:reduce)'
              ).matches ? 'instant' : 'smooth'
            });
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gokotta-comparison-evidence-0720"] && !Shopify.designMode) return;
  try {
    
  function gokottaInitComparisonEvidence0720(root) {
    if (!root || root.dataset.gokottaReady0720 === 'true') {
      return;
    }

    root.dataset.gokottaReady0720 = 'true';

    const desktopTriggers = Array.from(
      root.querySelectorAll(
        '[data-gokotta-desktop-trigger-0720]'
      )
    );

    const desktopImages = Array.from(
      root.querySelectorAll(
        '[data-gokotta-desktop-image-0720]'
      )
    );

    const desktopDetails = Array.from(
      root.querySelectorAll(
        '[data-gokotta-desktop-detail-0720]'
      )
    );

    const desktopItems = Array.from(
      root.querySelectorAll(
        '.gokotta-comparison-evidence-0720__desktop-item'
      )
    );

    const mobileTriggers = Array.from(
      root.querySelectorAll(
        '[data-gokotta-mobile-trigger-0720]'
      )
    );

    const mobileItems = Array.from(
      root.querySelectorAll(
        '.gokotta-comparison-evidence-0720__mobile-item'
      )
    );

    function gokottaSetIcon0720(trigger, selected) {
      const icon = trigger.querySelector('i');

      if (icon) {
        icon.textContent = selected ? '−' : '+';
      }
    }

    function selectItem(index) {
      desktopTriggers.forEach((trigger, itemIndex) => {
        const selected = itemIndex === index;

        trigger.setAttribute(
          'aria-expanded',
          String(selected)
        );

        gokottaSetIcon0720(trigger, selected);

        if (desktopItems[itemIndex]) {
          desktopItems[itemIndex].classList.toggle(
            'is-active',
            selected
          );
        }

        if (desktopDetails[itemIndex]) {
          desktopDetails[itemIndex].hidden = !selected;
        }

        if (desktopImages[itemIndex]) {
          desktopImages[itemIndex].hidden = !selected;
        }
      });

      mobileTriggers.forEach((trigger, itemIndex) => {
        const selected = itemIndex === index;

        trigger.setAttribute(
          'aria-expanded',
          String(selected)
        );

        gokottaSetIcon0720(trigger, selected);

        if (mobileItems[itemIndex]) {
          mobileItems[itemIndex].classList.toggle(
            'is-active',
            selected
          );

          const body = mobileItems[itemIndex].querySelector(
            '.gokotta-comparison-evidence-0720__mobile-body'
          );

          if (body) {
            body.hidden = !selected;
          }
        }
      });
    }

    desktopTriggers.forEach((trigger, index) => {
      trigger.addEventListener(
        'click',
        () => selectItem(index)
      );
    });

    mobileTriggers.forEach((trigger, index) => {
      trigger.addEventListener(
        'click',
        () => selectItem(index)
      );
    });
  }

  function gokottaMountComparisons0720(scope) {
    const source = scope || document;

    source
      .querySelectorAll(
        '[data-gokotta-comparison-evidence-0720]'
      )
      .forEach(gokottaInitComparisonEvidence0720);
  }

  gokottaMountComparisons0720(document);

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      gokottaMountComparisons0720(event.target);
    }
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gokotta-k3r7d5-sticky261026"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gk-k3r7d5-scroll261026')) {
    customElements.define(
      'gk-k3r7d5-scroll261026',
      class extends HTMLElement {
        connectedCallback() {
          if (this.controller261026) return;

          this.controller261026 = new AbortController();

          const signal261026 = this.controller261026.signal;

          this.menu261026 = this.querySelector('[data-menu261026]');
          this.toggle261026 = this.querySelector('[data-toggle261026]');
          this.close261026 = this.querySelector('[data-close261026]');
          this.frame261026 = null;
          this.editor261026 = false;

          this.toggle261026.addEventListener(
            'click',
            () => {
              this.setMenu261026(this.menu261026.hidden);

              if (!this.menu261026.hidden) {
                this.close261026.focus({ preventScroll: true });
              }
            },
            { signal: signal261026 }
          );

          this.close261026.addEventListener(
            'click',
            () => {
              this.setMenu261026(false);
              this.toggle261026.focus({ preventScroll: true });
            },
            { signal: signal261026 }
          );

          this.addEventListener(
            'click',
            (event261026) => {
              const link261026 = event261026.target.closest(
                '[data-product-open261026]'
              );

              if (!link261026) return;

              if (
                event261026.metaKey ||
                event261026.ctrlKey ||
                event261026.shiftKey ||
                event261026.altKey
              ) {
                return;
              }

              const target261026 = this.normalize261026(
                link261026.dataset.productUrl261026
              );

              let source261026 = null;

              if (customElements.get('gk-cedar-sheetshop261026')) {
                const records261026 = document.querySelectorAll(
                  'gk-cedar-sheetshop261026 .gk-cedar-block261026 [data-product261026]'
                );

                for (const record261026 of records261026) {
                  try {
                    const product261026 = JSON.parse(
                      record261026.textContent
                    );

                    if (
                      this.normalize261026(product261026.url) ===
                      target261026
                    ) {
                      source261026 = record261026
                        .closest('.gk-cedar-block261026')
                        .querySelector('[data-shop261026]');

                      if (source261026) break;
                    }
                  } catch {}
                }
              }

              this.setMenu261026(false);

              if (source261026) {
                event261026.preventDefault();
                source261026.click();
              }
            },
            { signal: signal261026 }
          );

          document.addEventListener(
            'click',
            (event261026) => {
              if (!this.contains(event261026.target)) {
                this.setMenu261026(false);
              }
            },
            { signal: signal261026 }
          );

          document.addEventListener(
            'keydown',
            (event261026) => {
              if (
                event261026.key === 'Escape' &&
                !this.menu261026.hidden
              ) {
                this.setMenu261026(false);
                this.toggle261026.focus({ preventScroll: true });
              }
            },
            { signal: signal261026 }
          );

          window.addEventListener(
            'scroll',
            () => this.queue261026(),
            { passive: true, signal: signal261026 }
          );

          window.addEventListener(
            'resize',
            () => this.queue261026(),
            { passive: true, signal: signal261026 }
          );

          window.addEventListener(
            'load',
            () => this.findBanner261026(),
            { once: true, signal: signal261026 }
          );

          window.addEventListener(
            'pageshow',
            () => this.findBanner261026(),
            { signal: signal261026 }
          );

          document.addEventListener(
            'shopify:section:load',
            () => this.findBanner261026(),
            { signal: signal261026 }
          );

          document.addEventListener(
            'shopify:section:reorder',
            () => this.findBanner261026(),
            { signal: signal261026 }
          );

          if (window.Shopify && window.Shopify.designMode) {
            document.addEventListener(
              'shopify:section:select',
              (event261026) => {
                if (
                  event261026.detail.sectionId !==
                  this.dataset.section261026
                ) return;

                this.editor261026 = true;
                this.queue261026();
              },
              { signal: signal261026 }
            );

            document.addEventListener(
              'shopify:section:deselect',
              (event261026) => {
                if (
                  event261026.detail.sectionId !==
                  this.dataset.section261026
                ) return;

                this.editor261026 = false;
                this.setMenu261026(false);
                this.queue261026();
              },
              { signal: signal261026 }
            );

            document.addEventListener(
              'shopify:block:select',
              (event261026) => {
                if (!this.contains(event261026.target)) return;

                this.editor261026 = true;
                this.update261026();
                this.setMenu261026(true);
              },
              { signal: signal261026 }
            );

            document.addEventListener(
              'shopify:block:deselect',
              (event261026) => {
                if (!this.contains(event261026.target)) return;

                this.editor261026 = false;
                this.setMenu261026(false);
                this.queue261026();
              },
              { signal: signal261026 }
            );
          }

          this.findBanner261026();
        }

        disconnectedCallback() {
          this.controller261026?.abort();
          this.controller261026 = null;
          this.observer261026?.disconnect();

          if (this.frame261026 !== null) {
            cancelAnimationFrame(this.frame261026);
          }

          this.frame261026 = null;
        }

        normalize261026(value261026) {
          if (!value261026) return '';

          try {
            const url261026 = new URL(
              value261026,
              window.location.origin
            );

            const path261026 = decodeURIComponent(
              url261026.pathname
            ).replace(/\/+$/, '');

            const parts261026 = path261026.split('/products/');

            return parts261026.length > 1
              ? parts261026[parts261026.length - 1]
              : path261026;
          } catch {
            return value261026;
          }
        }

        findBanner261026() {
          this.observer261026?.disconnect();
          this.banner261026 = null;

          const custom261026 = (
            this.dataset.banner261026 || ''
          ).trim();

          if (custom261026) {
            try {
              const candidate261026 = document.querySelector(
                custom261026
              );

              if (
                candidate261026 &&
                candidate261026 !== this &&
                !candidate261026.contains(this)
              ) {
                this.banner261026 = candidate261026;
              }
            } catch {}
          }

          if (!this.banner261026) {
            this.banner261026 = document.querySelector(
              '.gokotta-collection-banner, ' +
              '[data-gokotta-collection-banner], ' +
              'main .gk-collection-banner261026'
            );
          }

          if (!this.banner261026) {
            const main261026 = document.querySelector(
              '#MainContent, main'
            );

            const sections261026 = main261026
              ? main261026.querySelectorAll('.shopify-section')
              : [];

            this.banner261026 = Array.from(
              sections261026
            ).find((section261026) => {
              return (
                !section261026.contains(this) &&
                section261026.getBoundingClientRect().height > 100
              );
            }) || null;
          }

          if (
            this.banner261026 &&
            'ResizeObserver' in window
          ) {
            this.observer261026 = new ResizeObserver(
              () => this.queue261026()
            );

            this.observer261026.observe(this.banner261026);
          }

          this.queue261026();
        }

        queue261026() {
          if (this.frame261026 !== null) return;

          this.frame261026 = requestAnimationFrame(() => {
            this.frame261026 = null;
            this.update261026();
          });
        }

        update261026() {
          let visible261026 = this.editor261026;

          if (!visible261026) {
            if (
              this.banner261026 &&
              this.banner261026.isConnected
            ) {
              const rect261026 =
                this.banner261026.getBoundingClientRect();

              visible261026 = (
                rect261026.height > 0 &&
                rect261026.bottom <= 0
              );
            } else {
              visible261026 = window.scrollY >= window.innerHeight;
            }
          }

          const next261026 = visible261026 ? 'true' : 'false';

          if (this.dataset.visible261026 === next261026) return;

          if (!visible261026) {
            if (this.contains(document.activeElement)) {
              document.activeElement.blur();
            }

            this.setMenu261026(false);
          }

          this.dataset.visible261026 = next261026;
          this.setAttribute(
            'aria-hidden',
            visible261026 ? 'false' : 'true'
          );
          this.toggleAttribute('inert', !visible261026);
        }

        setMenu261026(open261026) {
          this.menu261026.hidden = !open261026;

          this.toggle261026.setAttribute(
            'aria-expanded',
            open261026 ? 'true' : 'false'
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gokotta-larkhaven-ugc261026"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gk-larkhaven-ugc261026')) {
    customElements.define(
      'gk-larkhaven-ugc261026',
      class extends HTMLElement {
        connectedCallback() {
          if (this.ready261026) return;
          this.ready261026 = true;

          const track261026 = this.querySelector('[data-track261026]');
          const cards261026 = [
            ...this.querySelectorAll('[data-card261026]')
          ];

          const videos261026 = cards261026.map(card261026 =>
            card261026.querySelector('[data-video261026]')
          );

          if (!track261026 || !cards261026.length) return;

          const count261026 = this.querySelector('[data-count261026]');
          const reduced261026 = matchMedia(
            '(prefers-reduced-motion:reduce)'
          );

          let active261026 = 0;
          let visible261026 = false;
          let paused261026 = reduced261026.matches;
          let scrollTimer261026;
          let programScroll261026 = false;
          let programTimer261026;

          const pauseAll261026 = () => {
            videos261026.forEach(video261026 => {
              if (video261026) video261026.pause();
            });
          };

          const sync261026 = () => {
            const modalOpen261026 = Boolean(
              document.querySelector('dialog[open]')
            );

            videos261026.forEach((video261026, index261026) => {
              if (!video261026) return;

              const shouldPlay261026 =
                index261026 === active261026 &&
                visible261026 &&
                !paused261026 &&
                !document.hidden &&
                !modalOpen261026;

              if (!shouldPlay261026) {
                video261026.pause();
                return;
              }

              if (
                video261026.dataset.source261026 &&
                !video261026.getAttribute('src')
              ) {
                video261026.src =
                  video261026.dataset.source261026;
              }

              video261026.play().catch(() => {});
            });

            count261026.textContent =
              String(active261026 + 1).padStart(2, '0') +
              ' / ' +
              String(cards261026.length).padStart(2, '0');
          };

          const select261026 = (
            index261026,
            scroll261026 = true
          ) => {
            active261026 =
              (index261026 + cards261026.length) %
              cards261026.length;

            if (videos261026[active261026]?.ended) {
              videos261026[active261026].currentTime = 0;
            }

            if (scroll261026) {
              programScroll261026 = true;
              clearTimeout(programTimer261026);

              track261026.scrollTo({
                left:
                  cards261026[active261026].offsetLeft -
                  cards261026[0].offsetLeft,
                behavior: reduced261026.matches
                  ? 'instant'
                  : 'smooth'
              });

              programTimer261026 = setTimeout(() => {
                programScroll261026 = false;
              }, 600);
            }

            sync261026();
          };

          videos261026.forEach((video261026, index261026) => {
            if (!video261026) return;

            video261026.muted = true;
            video261026.defaultMuted = true;
            video261026.playsInline = true;

            const card261026 = cards261026[index261026];
            const play261026 =
              card261026.querySelector('[data-play261026]');
            const sound261026 =
              card261026.querySelector('[data-sound261026]');

            video261026.addEventListener('playing', () => {
              card261026.dataset.playing261026 = 'true';
              play261026.setAttribute(
                'aria-label',
                'Pause customer video'
              );
            });

            video261026.addEventListener('pause', () => {
              card261026.dataset.playing261026 = 'false';
              play261026.setAttribute(
                'aria-label',
                'Play customer video'
              );
            });

            video261026.addEventListener('ended', () => {
              if (!paused261026 && visible261026) {
                select261026(index261026 + 1);
              }
            });

            play261026.addEventListener('click', () => {
              if (
                active261026 === index261026 &&
                !video261026.paused
              ) {
                paused261026 = true;
                sync261026();
              } else {
                paused261026 = false;
                select261026(index261026, false);
              }
            });

            sound261026.addEventListener('click', () => {
              const unmute261026 = video261026.muted;

              videos261026.forEach((other261026, i261026) => {
                if (!other261026) return;

                other261026.muted = true;

                const button261026 = cards261026[i261026]
                  .querySelector('[data-sound261026]');

                button261026.setAttribute('aria-pressed', 'false');
                button261026.setAttribute(
                  'aria-label',
                  'Turn sound on'
                );
              });

              video261026.muted = !unmute261026;

              sound261026.setAttribute(
                'aria-pressed',
                String(unmute261026)
              );

              sound261026.setAttribute(
                'aria-label',
                unmute261026 ? 'Turn sound off' : 'Turn sound on'
              );

              paused261026 = false;
              select261026(index261026, false);
            });
          });

          this.querySelector('[data-prev261026]')
            .addEventListener('click', () => {
              paused261026 = false;
              select261026(active261026 - 1);
            });

          this.querySelector('[data-next261026]')
            .addEventListener('click', () => {
              paused261026 = false;
              select261026(active261026 + 1);
            });

          track261026.addEventListener('scroll', () => {
            if (programScroll261026) return;

            clearTimeout(scrollTimer261026);

            scrollTimer261026 = setTimeout(() => {
              if (
                track261026.scrollWidth <=
                track261026.clientWidth + 2
              ) return;

              const start261026 =
                cards261026[0].offsetLeft;

              const nearest261026 = cards261026.reduce(
                (best261026, card261026, index261026) => {
                  const distance261026 = Math.abs(
                    card261026.offsetLeft -
                    start261026 -
                    track261026.scrollLeft
                  );

                  const bestDistance261026 = Math.abs(
                    cards261026[best261026].offsetLeft -
                    start261026 -
                    track261026.scrollLeft
                  );

                  return distance261026 < bestDistance261026
                    ? index261026
                    : best261026;
                },
                0
              );

              select261026(nearest261026, false);
            }, 150);
          }, { passive: true });

          const observer261026 = new IntersectionObserver(
            entries261026 => {
              visible261026 = entries261026[0].isIntersecting;
              sync261026();
            },
            { threshold: 0.2 }
          );

          observer261026.observe(track261026);

          this.addEventListener('click', event261026 => {
            if (
              event261026.target.closest('[data-shop261026]')
            ) {
              pauseAll261026();

              if (
                !customElements.get('gk-cedar-sheetshop261026')
              ) {
                const card261026 = event261026.target.closest(
                  '[data-card261026]'
                );

                const link261026 = card261026?.querySelector(
                  '.gk-larkhaven-productlink261026'
                );

                if (link261026) {
                  window.location.assign(link261026.href);
                }
              }
            }
          });

          this.querySelectorAll('dialog').forEach(dialog261026 => {
            dialog261026.addEventListener('close', sync261026);
          });

          const visibility261026 = () => sync261026();
          document.addEventListener(
            'visibilitychange',
            visibility261026
          );

          const modalObserver261026 = new MutationObserver(
            mutations261026 => {
              if (
                mutations261026.some(
                  mutation261026 =>
                    mutation261026.target.tagName === 'DIALOG'
                )
              ) sync261026();
            }
          );

          modalObserver261026.observe(document.body, {
            subtree: true,
            attributes: true,
            attributeFilter: ['open']
          });

          this.cleanup261026 = () => {
            pauseAll261026();
            observer261026.disconnect();
            modalObserver261026.disconnect();
            clearTimeout(scrollTimer261026);
            clearTimeout(programTimer261026);
            document.removeEventListener(
              'visibilitychange',
              visibility261026
            );
          };

          sync261026();
        }

        disconnectedCallback() {
          if (this.cleanup261026) this.cleanup261026();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gokotta-product-faq-0720"] && !Shopify.designMode) return;
  try {
    
  function bs310tcInitProductFaq0720(root) {
    if (!root || root.dataset.bs310tcFaqReady0720 === 'true') {
      return;
    }

    root.dataset.bs310tcFaqReady0720 = 'true';

    const items = Array.from(
      root.querySelectorAll('[data-bs310tc-faq-item-0720]')
    );

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) {
          return;
        }

        items.forEach((otherItem) => {
          if (otherItem !== item) {
            otherItem.open = false;
          }
        });
      });
    });
  }

  function bs310tcMountProductFaq0720(scope) {
    const source = scope || document;

    source
      .querySelectorAll('[data-bs310tc-product-faq-0720]')
      .forEach(bs310tcInitProductFaq0720);
  }

  bs310tcMountProductFaq0720(document);

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      bs310tcMountProductFaq0720(event.target);
    }
  );

  document.addEventListener(
    'shopify:block:select',
    (event) => {
      const item = event.target.closest(
        '[data-bs310tc-faq-item-0720]'
      );

      if (item) {
        item.open = true;
      }
    }
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gokotta-tidefern-fit261026"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gk-tidefern-fit261026')) {
    customElements.define('gk-tidefern-fit261026', class extends HTMLElement {
      connectedCallback() {
        if (this.isReady) return;
        this.isReady = true;

        const tabs = Array.from(this.querySelectorAll('[data-fit261026]'));
        const panels = Array.from(this.querySelectorAll('[data-panel261026]'));
        const imgEl = this.querySelector('img[data-image261026]');
        const captionSpan = this.querySelector('[data-caption261026] > span');

        const activateTab = (index) => {
          if (!tabs[index]) return;
          tabs.forEach((tab, i) => {
            tab.setAttribute('aria-selected', String(i === index));
            tab.tabIndex = (i === index) ? 0 : -1;
          });
          panels.forEach((panel, i) => {
            panel.hidden = (i !== index);
          });
          imgEl.src = tabs[index].dataset.image261026;
          imgEl.alt = tabs[index].dataset.alt261026;
          captionSpan.textContent = tabs[index].dataset.caption261026;
        };

        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => activateTab(index));
          
          // 彻底修复丢失减号的语法错误，恢复丝滑的键盘箭头控制
          tab.addEventListener('keydown', e => {
            let next = index;
            if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
              next = (index + 1) % tabs.length;
            } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
              next = (index - 1 + tabs.length) % tabs.length;
            } else if (e.key === 'Home') {
              next = 0;
            } else if (e.key === 'End') {
              next = tabs.length - 1;
            } else {
              return;
            }
            e.preventDefault();
            activateTab(next);
            tabs[next].focus();
          });
        });

        this.addEventListener('shopify:block:select', e => {
          const t = e.target.closest('[data-fit261026]');
          if (t) activateTab(Number(t.dataset.fit261026));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gokotta-willowfen-shop261026"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gk-cedar-sheetshop261026')) {
    customElements.define(
      'gk-cedar-sheetshop261026',
      class extends HTMLElement {
        connectedCallback() {
          if (this.ready261026) return;
          this.ready261026 = true;

          const q261026 = selector261026 =>
            this.querySelector(selector261026);

          const modal261026 = q261026('.gk-cedar-pv-sheet261026');
          const compare261026 = q261026('.gk-cedar-compare261026');
          const options261026 = q261026('[data-options261026]');
          const gallery261026 = q261026('[data-gallery261026]');
          const add261026 = q261026('[data-add261026]');
          const status261026 = q261026('[data-status261026]');

          const money261026 = new Intl.NumberFormat(
            document.documentElement.lang || 'en-US',
            {
              style: 'currency',
              currency: this.dataset.currency261026
            }
          );

          const root261026 =
            this.dataset.root261026.replace(/\/?$/, '/');

          const cards261026 = [
            ...this.querySelectorAll('.gk-cedar-card261026')
          ];

          const mobile261026 = matchMedia('(max-width:700px)');

          let product261026;
          let variants261026 = [];
          let selected261026 = [];
          let variant261026;
          let busy261026 = false;

          const node261026 = (
            tag261026,
            class261026,
            text261026
          ) => {
            const element261026 =
              document.createElement(tag261026);

            if (class261026) {
              element261026.className = class261026;
            }

            if (text261026 !== undefined) {
              element261026.textContent = text261026;
            }

            return element261026;
          };

          const layout261026 = () => {
            cards261026.forEach(card261026 => {
              card261026.open = !mobile261026.matches;
            });
          };

          layout261026();
          mobile261026.addEventListener('change', layout261026);

          cards261026.forEach(card261026 => {
            card261026.querySelector('summary').addEventListener(
              'click',
              event261026 => {
                if (!mobile261026.matches) {
                  event261026.preventDefault();
                } else if (!card261026.open) {
                  cards261026.forEach(other261026 => {
                    if (other261026 !== card261026) {
                      other261026.open = false;
                    }
                  });
                }
              }
            );
          });

          this.addEventListener(
            'shopify:block:select',
            event261026 => {
              const card261026 = event261026.target
                .closest('.gk-cedar-block261026')
                ?.querySelector('details');

              if (card261026) card261026.open = true;
            }
          );

          this.querySelectorAll('dialog').forEach(dialog261026 => {
            dialog261026.addEventListener(
              'cancel',
              event261026 => {
                if (busy261026) event261026.preventDefault();
              }
            );

            dialog261026.addEventListener(
              'click',
              event261026 => {
                if (busy261026) return;

                if (
                  event261026.target.closest('[data-close261026]')
                ) {
                  dialog261026.close();
                  return;
                }

                if (event261026.target === dialog261026) {
                  const rect261026 =
                    dialog261026.getBoundingClientRect();

                  if (
                    event261026.clientX < rect261026.left ||
                    event261026.clientX > rect261026.right ||
                    event261026.clientY < rect261026.top ||
                    event261026.clientY > rect261026.bottom
                  ) {
                    dialog261026.close();
                  }
                }
              }
            );
          });

          const color261026 = name261026 => (
            {
              storm: '#537585',
              'storm blue': '#537585',
              'deep slate': '#3f5359',
              'silver sage': '#819180',
              'cocoa brown': '#74513f',
              charcoal: '#5e6364',
              dune: '#c5b49d',
              snow: '#f5f3ed',
              oatmeal: '#cdbca4',
              'cloud white': '#f4f1e9',
              'silver grey': '#b4b6b8',
              'forest green': '#285346',
              emerald: '#285346'
            }[name261026.toLowerCase()] || '#d8d7cc'
          );

          const refresh261026 = () => {
            variant261026 = variants261026.find(item261026 =>
              item261026.options.every(
                (value261026, index261026) =>
                  value261026 === selected261026[index261026]
              )
            );

            const price261026 = q261026('[data-price261026]');
            price261026.replaceChildren();

            if (variant261026) {
              const current261026 = variant261026.price;
              const comparePrice261026 =
                variant261026.compare_at_price;

              if (comparePrice261026 > current261026) {
                price261026.append(
                  node261026(
                    'span',
                    'gk-cedar-pv-compare261026',
                    money261026.format(comparePrice261026 / 100)
                  )
                );
              }

              price261026.append(
                node261026(
                  'span',
                  'gk-cedar-pv-price261026',
                  money261026.format(current261026 / 100)
                )
              );

              if (comparePrice261026 > current261026) {
                price261026.append(
                  node261026(
                    'span',
                    'gk-cedar-pv-badge--sale261026',
                    Math.round(
                      (comparePrice261026 - current261026) *
                      100 / comparePrice261026
                    ) + '% OFF'
                  )
                );
              }
            } else {
              price261026.append(
                node261026(
                  'span',
                  'gk-cedar-pv-price261026',
                  'Unavailable'
                )
              );
            }

            options261026.querySelectorAll('button').forEach(
              button261026 => {
                button261026.setAttribute(
                  'aria-pressed',
                  String(
                    selected261026[
                      Number(button261026.dataset.index261026)
                    ] === button261026.dataset.value261026
                  )
                );

                button261026.disabled = busy261026;
              }
            );

            add261026.disabled =
              busy261026 || !variant261026?.available;

            add261026.textContent = busy261026
              ? 'Adding…'
              : !variant261026
                ? 'Unavailable'
                : variant261026.available
                  ? 'Add to cart'
                  : 'Sold out';

            q261026('[data-details261026]').href =
              product261026.url +
              (
                variant261026
                  ? '?variant=' + variant261026.id
                  : ''
              );

            if (variant261026?.featured_image) {
              const target261026 = [
                ...gallery261026.children
              ].find(image261026 =>
                image261026.getAttribute('src').split('?')[0] ===
                variant261026.featured_image.split('?')[0]
              );

              if (target261026) {
                gallery261026.scrollTo({
                  left:
                    target261026.offsetLeft -
                    gallery261026.firstElementChild.offsetLeft,
                  behavior: matchMedia(
                    '(prefers-reduced-motion:reduce)'
                  ).matches ? 'instant' : 'smooth'
                });
              }
            }
          };

          const openProduct261026 = block261026 => {
            product261026 = JSON.parse(
              block261026.querySelector(
                '[data-product261026]'
              ).textContent
            );

            variants261026 = product261026.variants;

            if (product261026.spec.includes('310TC')) {
              const classic261026 = variants261026.filter(
                item261026 =>
                  item261026.options.some(value261026 =>
                    /310\s*TC/i.test(value261026)
                  )
              );

              if (classic261026.length) {
                variants261026 = classic261026;
              }
            }

            const first261026 =
              variants261026.find(
                item261026 => item261026.available
              ) || variants261026[0];

            selected261026 =
              first261026?.options.slice() || [];

            q261026('[data-title261026]').textContent =
              product261026.title;

            status261026.textContent = first261026
              ? ''
              : 'Please view full details to choose this product.';

            gallery261026.replaceChildren();

            const images261026 = product261026.images.length
              ? product261026.images
              : [product261026.fallback_image];

            images261026.forEach((url261026, index261026) => {
              const image261026 = node261026(
                'img',
                'gk-cedar-pv-image261026'
              );

              image261026.src = url261026;
              image261026.alt =
                product261026.title +
                ' — image ' + (index261026 + 1);

              image261026.width = 800;
              image261026.height = 800;
              image261026.loading =
                index261026 === 0 ? 'eager' : 'lazy';

              gallery261026.append(image261026);
            });

            options261026.replaceChildren();

            product261026.options.forEach(
              (option261026, index261026) => {
                const values261026 = [
                  ...new Set(
                    variants261026.map(
                      item261026 =>
                        item261026.options[index261026]
                    )
                  )
                ];

                if (values261026.length < 2) return;

                const group261026 = node261026(
                  'div',
                  'gk-cedar-pv-option261026'
                );

                group261026.append(
                  node261026(
                    'p',
                    'gk-cedar-pv-option-label261026',
                    option261026.name
                  )
                );

                const buttons261026 = node261026(
                  'div',
                  'gk-cedar-pv-option-values261026'
                );

                buttons261026.setAttribute('role', 'group');
                buttons261026.setAttribute(
                  'aria-label',
                  option261026.name
                );

                const isColor261026 =
                  /color|colour/i.test(option261026.name);

                values261026.forEach(value261026 => {
                  const button261026 = node261026(
                    'button',
                    'gk-cedar-pv-option-button261026' +
                    (
                      isColor261026
                        ? ' gk-cedar-pv-swatch-button261026'
                        : ''
                    ),
                    value261026
                  );

                  button261026.type = 'button';
                  button261026.title = value261026;
                  button261026.setAttribute(
                    'aria-label',
                    value261026
                  );

                  button261026.dataset.index261026 = index261026;
                  button261026.dataset.value261026 = value261026;

                  if (isColor261026) {
                    const swatch261026 =
                      product261026.swatches.find(
                        item261026 =>
                          item261026.name === value261026
                      );

                    button261026.style.backgroundColor =
                      swatch261026?.color ||
                      color261026(value261026);

                    if (swatch261026?.image) {
                      button261026.style.backgroundImage =
                        'url(' +
                        JSON.stringify(swatch261026.image) +
                        ')';
                    }
                  }

                  button261026.addEventListener('click', () => {
                    if (busy261026) return;

                    selected261026[index261026] = value261026;
                    status261026.textContent = '';

                    refresh261026();

                    group261026.querySelector('p').textContent =
                      option261026.name + ' — ' + value261026;
                  });

                  buttons261026.append(button261026);
                });

                group261026.append(buttons261026);
                options261026.append(group261026);
              }
            );

            refresh261026();
            modal261026.showModal();

            q261026(
              '.gk-cedar-pv-body261026'
            ).scrollTop = 0;

            gallery261026.scrollLeft = 0;
            refresh261026();
          };

          this.addEventListener('click', event261026 => {
            const comparePick261026 =
              event261026.target.closest(
                '[data-compare-pick261026]'
              );

            if (comparePick261026) {
              if (busy261026) return;

              const targetSpec261026 =
                comparePick261026.getAttribute(
                  'data-compare-pick261026'
                );

              const targetBlock261026 = [
                ...this.querySelectorAll(
                  '.gk-cedar-block261026'
                )
              ].find(block261026 => {
                const data261026 =
                  block261026.querySelector(
                    '[data-product261026]'
                  );

                if (!data261026) return false;

                return JSON.parse(data261026.textContent)
                  .spec.includes(targetSpec261026);
              });

              if (targetBlock261026) {
                compare261026.close();
                openProduct261026(targetBlock261026);
              }

              return;
            }

            if (
              event261026.target.closest('[data-compare261026]')
            ) {
              compare261026.showModal();
              return;
            }

            const trigger261026 =
              event261026.target.closest('[data-shop261026]');

            if (!trigger261026 || busy261026) return;

            const block261026 = trigger261026.closest(
              '.gk-cedar-block261026'
            );

            openProduct261026(block261026);
          });

          add261026.addEventListener('click', async () => {
            if (
              busy261026 ||
              !variant261026?.available
            ) return;

            busy261026 = true;
            status261026.textContent = '';
            refresh261026();

            let added261026;

            try {
              const response261026 = await fetch(
                root261026 + 'cart/add.js',
                {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                  },
                  body: JSON.stringify({
                    items: [{
                      id: variant261026.id,
                      quantity: 1
                    }]
                  })
                }
              );

              const result261026 = await response261026.json();

              if (!response261026.ok) {
                throw Error(
                  result261026.description ||
                  'Unable to add this item. Please try again.'
                );
              }

              added261026 =
                result261026.items?.[0] || result261026;
            } catch (error261026) {
              status261026.textContent = error261026.message;
            }

            busy261026 = false;
            refresh261026();

            if (!added261026) return;

            modal261026.close();

            document.dispatchEvent(
              new CustomEvent('ajaxProduct:added', {
                detail: { product: added261026 }
              })
            );

            document.dispatchEvent(
              new CustomEvent('cart:build')
            );

            setTimeout(() => {
              const drawer261026 =
                document.getElementById('CartDrawer');

              if (
                drawer261026?.classList.contains('is-open') ||
                drawer261026?.classList.contains(
                  'drawer--is-open'
                )
              ) return;

              if (
                typeof window.theme?.Drawers?.cart?.open ===
                'function'
              ) {
                window.theme.Drawers.cart.open();
              } else {
                const trigger261026 = document.querySelector(
                  'a.js-drawer-open-cart,' +
                  'button.js-drawer-open-cart'
                );

                if (trigger261026) {
                  trigger261026.click();
                } else {
                  window.location.assign(root261026 + 'cart');
                }
              }
            }, 250);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
